<script lang="ts">
  import { addBusinessDays, format, isSameMonth } from 'date-fns';
  import { cn } from '$lib/utils';
  import { t } from '$lib/i18n';
  import { region, type Region } from '$lib/region';
  import { geolocation } from '$lib/stores/geolocation';
  import { CountryCode } from '$gql/storefront/schemas';

  let className: string | undefined = undefined;
  export { className as class };

  export let start: string | undefined = undefined;
  export let customMessage: string | undefined = undefined;

  /**
    Delivery range (business days)

    // UK STORE
    default: 1 – 3

    // EU STORE
    country DE: 1 – 3
    default: 1 – 5

    // US STORE
    NE states (all): 1 – 5
    CA: 2 – 9
    AU: 3 – 20
    default: 2 – 7
   */

  const getRange = (storeRegion: Region, country?: CountryCode, regionCode?: string) => {
    switch (storeRegion) {
      case 'uk':
        return [1, 3];
      case 'eu':
        if (country === CountryCode.De) {
          return [1, 3];
        } else {
          return [1, 5];
        }
      case 'us':
        if (
          regionCode &&
          ['CT', 'DE', 'MA', 'MD', 'ME', 'NH', 'NJ', 'NY', 'PA', 'RI', 'VT'].includes(regionCode)
        ) {
          return [1, 5];
        } else if (
          country === CountryCode.Ca &&
          regionCode &&
          ['ON', 'QC', 'NB', 'NS'].includes(regionCode)
        ) {
          return [1, 4];
        } else if (country === CountryCode.Ca) {
          return [2, 7];
        } else if (country === CountryCode.Au) {
          return [3, 20];
        } else {
          return [2, 7];
        }
    }
  };

  $: range = getRange($region, $geolocation?.country, $geolocation?.regionCode);
  $: fromDate = start
    ? addBusinessDays(new Date(start), range[0])
    : addBusinessDays(new Date(), range[0]);
  $: toDate = start
    ? addBusinessDays(new Date(start), range[1])
    : addBusinessDays(new Date(), range[1]);
  $: sameMonth = isSameMonth(fromDate, toDate);
</script>

<span class={cn('block text-sm', className)}>
  {#if customMessage}
    {customMessage}
  {:else}
    {$t('pdp.delivery-on', {
      value: sameMonth
        ? `${format(fromDate, 'MMMM do')} - ${format(toDate, 'do')}`
        : `${format(fromDate, 'MMMM do')} - ${format(toDate, 'MMMM do')}`
    })}
  {/if}
</span>
